const gallery = (id) => {
  const prefix = `/img/products/p${String(id).padStart(2, "0")}`;
  return [`${prefix}-1.webp`, `${prefix}-2.webp`, `${prefix}-3.webp`];
};

const productData = [
  {
    id: 1,
    name: "Mended Heart Porcelain Vase",
    category: "Vases",
    price: 168,
    stock: 12,
    image: gallery(1)[0],
    images: gallery(1),
    size: ["16.5 × 9 × 25 cm"],
    colors: ["Ivory / warm gold"],
    material: "Glazed porcelain with metallic-effect detailing",
    description: [
      "A sculptural flower vase with several narrow openings that separate stems while keeping a compact footprint. The abstract heart form works as a table object when empty and holds light-cut flowers when in use.",
      "Dimensions are approximately 16.5 × 9 × 25 cm. The ivory glaze and hand-applied warm-gold lines may show small tonal or line-width variations. Use with cool or room-temperature water only.",
      "Hand wash with a soft cloth and mild detergent, then dry the exterior promptly. Do not use abrasive pads, a dishwasher, microwave, or sudden temperature changes. Fragile: keep away from edges and discard if cracked or chipped.",
    ],
    Features: ["Multi-opening flower display", "Glazed fine porcelain", "Decorative metallic-effect seams", "Indoor decorative use"],
  },
  {
    id: 2,
    name: "Cobalt Arc Porcelain Vase",
    category: "Vases",
    price: 154,
    stock: 9,
    image: gallery(2)[0],
    images: gallery(2),
    size: ["23 cm diameter × 26 cm high"],
    colors: ["Warm white / cobalt blue"],
    material: "Glazed porcelain",
    description: [
      "An offset-neck flower vase with a broad oval body and original cobalt brush arcs. Its stable base suits short branches, leafy stems, or an uncluttered shelf display.",
      "Approximate size is 23 cm at the widest point and 26 cm high. Brush density, speckling and glaze pooling differ slightly from piece to piece; these are visual characteristics rather than defects.",
      "Rinse after use and hand wash with a non-scratch sponge. Avoid dishwasher heat, boiling water and hard impacts. Place a protective mat beneath the vase on moisture-sensitive surfaces.",
    ],
    Features: ["Offset oval opening", "Original cobalt arc motif", "Water-holding glazed interior", "Protective mat recommended"],
  },
  {
    id: 3,
    name: "Oxblood Ripple Wall Mirror",
    category: "Mirrors",
    price: 128,
    stock: 17,
    image: gallery(3)[0],
    images: gallery(3),
    size: ["22.5 × 29.5 cm"],
    colors: ["Oxblood / blush"],
    material: "Glass mirror with moulded resin frame",
    description: [
      "A compact wall mirror framed by a softly irregular oxblood-red ripple and a narrow blush inner edge. It is sized for an entryway, dressing corner, or decorative gallery arrangement.",
      "The overall size is approximately 22.5 × 29.5 cm. Reflections and colours vary with surrounding light and screen settings; the frame has a glossy, slightly marbled finish.",
      "Mount only with hardware suitable for the wall material and mirror weight; hardware is not included. Wipe glass with cleaner applied to a cloth, never directly onto the frame. Handle with two hands and stop using if glass is chipped or cracked.",
    ],
    Features: ["Compact wall format", "Irregular resin frame", "Vertical hanging orientation", "Mounting hardware not included"],
  },
  {
    id: 4,
    name: "Midnight Garden Dinner Plate",
    category: "Tableware",
    price: 92,
    stock: 24,
    image: gallery(4)[0],
    images: gallery(4),
    size: ["27 cm diameter × 2.3 cm high"],
    colors: ["Warm white / midnight blue / terracotta"],
    material: "Glazed porcelain",
    description: [
      "A 27 cm dinner plate bordered with an original midnight-blue botanical line drawing and a small terracotta crescent. The open centre leaves generous space for everyday mains or shared starters.",
      "Approximate height is 2.3 cm. Fine variations in the printed line and warm rim tone can occur. The photographed colour may appear different under cool or warm household lighting.",
      "Dishwasher safe on a gentle cycle; hand washing best preserves the rim. Do not expose to direct flame or thermal shock. Check for chips before food use and do not use a damaged plate.",
    ],
    Features: ["27 cm dinner format", "Food-contact glazed surface", "Gentle-cycle dishwasher safe", "Original botanical artwork"],
  },
  {
    id: 5,
    name: "Sage Horizon Dinner Plate",
    category: "Tableware",
    price: 88,
    stock: 31,
    image: gallery(5)[0],
    images: gallery(5),
    size: ["27 cm diameter × 2.3 cm high"],
    colors: ["Sage / warm white / charcoal"],
    material: "Glazed porcelain",
    description: [
      "A calm two-tone dinner plate divided by a hand-drawn charcoal horizon. The shallow curve supports plated meals while the restrained surface pairs easily with plain glassware and linens.",
      "The plate measures approximately 27 cm across and 2.3 cm high. Small speckles and changes along the dividing line are expected from the finishing process.",
      "Use for serving food, not stovetop cooking. Dishwasher safe on a gentle cycle; avoid abrasive powders and sudden changes from freezer to hot water. Retire the plate if a crack reaches the food surface.",
    ],
    Features: ["Two-tone surface", "Low coupe profile", "Food-contact glaze", "Gentle-cycle dishwasher safe"],
  },
  {
    id: 6,
    name: "Saffron Tide Dinner Plate",
    category: "Tableware",
    price: 86,
    stock: 19,
    image: gallery(6)[0],
    images: gallery(6),
    size: ["27 cm diameter × 2.3 cm high"],
    colors: ["Saffron / coral / warm white"],
    material: "Glazed porcelain",
    description: [
      "A bright porcelain dinner plate with a broad saffron wave and a muted coral circle. Its open design gives everyday meals a graphic accent without crowding the food presentation.",
      "Approximate dimensions are 27 cm diameter and 2.3 cm high. The colour blocks have a softly textured finish; placement and saturation may vary slightly between pieces.",
      "Suitable for normal table service. Wash on a gentle dishwasher cycle or by hand with mild detergent. Avoid metal scouring pads, direct heat, and use after a deep chip or crack appears.",
    ],
    Features: ["Graphic wave motif", "Low-profile rim", "Food-contact glaze", "Everyday table service"],
  },
  {
    id: 7,
    name: "Indigo Arc Dinner Plate",
    category: "Tableware",
    price: 90,
    stock: 27,
    image: gallery(7)[0],
    images: gallery(7),
    size: ["27 cm diameter × 2.3 cm high"],
    colors: ["Indigo / pale blue / warm white"],
    material: "Glazed porcelain",
    description: [
      "A contemporary dinner plate defined by a loose indigo brush arc and a pale-blue block. The broad centre and gently raised edge suit rice dishes, salads, and everyday mains.",
      "It measures approximately 27 cm in diameter and 2.3 cm high. Brush texture, edge fade and glaze tone are intentionally variable, so no two pieces look mechanically identical.",
      "Dishwasher safe on a gentle cycle. Stack with a soft separator if you want to protect the decorated face. Do not move the plate directly between extreme temperatures or continue using a damaged piece.",
    ],
    Features: ["Loose indigo brushwork", "Broad dining surface", "Food-contact glaze", "Soft separator recommended for storage"],
  },
  {
    id: 8,
    name: "Daybreak Window Accent Lamp",
    category: "Home Decor",
    price: 180,
    stock: 8,
    image: gallery(8)[0],
    images: gallery(8),
    size: ["57 × 90 cm"],
    colors: ["Pale oak / cream / dusty blue"],
    material: "Wood frame, frosted acrylic diffuser and integrated LED module",
    description: [
      "A freestanding window-inspired accent lamp that casts a muted cream-to-dusty-blue gradient. It is intended for ambient indoor lighting, not as the sole task light in a workspace.",
      "The frame is approximately 57 × 90 cm. The frosted acrylic softens the integrated LED output; perceived colour depends on surrounding light and display settings. Use only with the voltage and plug compatibility stated on the supplied electrical label.",
      "Keep upright on a dry, stable surface with ventilation around the frame. Unplug before cleaning and use a dry microfibre cloth. Do not cover, expose to moisture, modify the wiring, or operate if the cable, plug or diffuser is damaged.",
    ],
    Features: ["Ambient gradient light", "Frosted acrylic diffuser", "Indoor dry-location use", "Compatible rated supply required"],
  },
  {
    id: 9,
    name: "Dark and milk chocolate easter eggs",
    category: "Food",
    price: 58,
    stock: 36,
    image: gallery(9)[0],
    images: gallery(9),
    size: ["180 g box"],
    colors: ["Dark and milk chocolate"],
    material: "Chocolate confectionery with hazelnut praline",
    description: [
      "A mixed box of smooth dark and milk chocolate eggs with a soft hazelnut-praline centre and small roasted nut pieces. Serve at room temperature as a seasonal table treat or shareable confectionery.",
      "Net weight is approximately 180 g. Contains hazelnuts and milk; may contain traces of other nuts, peanuts, gluten, soy and egg where handled in a shared production setting. Check the pack label delivered with the product for the final ingredient and date information before eating.",
      "Store sealed in a cool, dry place away from sunlight and strong odours; do not refrigerate unless the pack label instructs otherwise. Food items cannot be returned after opening unless faulty, damaged or incorrectly supplied.",
    ],
    Features: ["Dark and milk assortment", "Hazelnut-praline centre", "180 g presentation box", "Allergen check required before eating"],
    perishable: true,
  },
  {
    id: 10,
    name: "Forest Hare Keepsake Egg",
    category: "Food",
    price: 64,
    stock: 22,
    image: gallery(10)[0],
    images: gallery(10),
    size: ["16 cm high tin / 160 g confectionery"],
    colors: ["Moss green / cream"],
    material: "Printed steel tin with dark chocolate bites",
    description: [
      "A reusable moss-green egg-shaped tin with a simple geometric hare illustration. Inside is approximately 160 g of individually arranged dark chocolate bites with a crisp cocoa finish.",
      "The tin is about 16 cm high. The confectionery may contain milk, nuts, peanuts, gluten, soy and egg; confirm the delivered ingredient label before consumption. The tin is decorative storage after all food-contact liners are removed.",
      "Keep the sealed chocolates cool and dry and observe the date on the delivered pack. Wipe the empty tin with a dry or barely damp cloth and dry at once; do not place it in a dishwasher. Small hinge parts and confectionery make this unsuitable for unsupervised young children.",
    ],
    Features: ["Reusable steel keepsake tin", "Geometric hare artwork", "Approx. 160 g dark chocolate", "Ingredient label governs allergens"],
    perishable: true,
  },
  {
    id: 11,
    name: "Midnight Wolf Keepsake Egg",
    category: "Food",
    price: 66,
    stock: 14,
    image: gallery(11)[0],
    images: gallery(11),
    size: ["16 cm high tin / 160 g confectionery"],
    colors: ["Midnight blue / rust / pale blue"],
    material: "Printed steel tin with assorted chocolate bites",
    description: [
      "A midnight-blue reusable tin decorated with an original angular wolf motif. The 160 g assortment combines milk and dark chocolate bites in several simple textures.",
      "The egg-shaped tin is approximately 16 cm high. Chocolate ingredients may include milk, nuts, peanuts, gluten, soy and egg; read the physical pack before eating or serving to someone with an allergy.",
      "Store closed in a dry place away from heat and sunlight. Once empty, remove liners and wipe the tin by hand, drying the hinge immediately. The metal edge and small hinge require adult supervision around children.",
    ],
    Features: ["Original angular wolf artwork", "Reusable steel tin", "Milk and dark assortment", "Adult supervision recommended"],
    perishable: true,
  },
  {
    id: 12,
    name: "Pin's Rond",
    category: "Accessories",
    price: 45,
    stock: 43,
    image: gallery(12)[0],
    images: gallery(12),
    size: ["28 mm diameter"],
    colors: ["Teal / cream / apricot"],
    material: "Enamelled metal with butterfly clasp",
    description: [
      "A 28 mm round enamel pin with an original arch-and-sun landscape motif. It adds a small graphic accent to a jacket, cap, fabric pouch or display board.",
      "The polished brass-tone edge surrounds teal, cream and apricot enamel. Minor differences in fill level can occur. The pin makes a permanent puncture in fabric, so test placement on a hidden area first.",
      "Keep dry, wipe with a soft cloth and remove before washing the attached item. The point and small clasp are not a toy; keep away from young children and store with the clasp secured.",
    ],
    Features: ["28 mm round format", "Original landscape motif", "Butterfly clasp", "Small sharp component"],
  },
  {
    id: 13,
    name: "Landscape Patches",
    category: "Accessories",
    price: 49,
    stock: 34,
    image: gallery(13)[0],
    images: gallery(13),
    size: ["Set of 3 / approx. 6 × 5 cm each"],
    colors: ["Sky blue / moss / rust"],
    material: "Polyester embroidery with heat-activated backing",
    description: [
      "A set of three rounded embroidered patches with an abstract three-colour landscape. Use them to repair or personalise compatible cotton and denim accessories.",
      "Each patch is approximately 6 × 5 cm. Stitch direction and border width may vary slightly. Heat-activated backing is not suitable for leather, waterproof coatings, stretch synthetics or heat-sensitive fabrics.",
      "Follow the garment's care label and test heat on a hidden area. Use a pressing cloth, allow the patch to cool flat, and add perimeter stitches for high-wear pieces. Adult handling is required when using an iron or needle.",
    ],
    Features: ["Set of three", "Heat-activated backing", "Optional stitch reinforcement", "Not for heat-sensitive materials"],
  },
  {
    id: 14,
    name: "Grid Cotton Bandana",
    category: "Accessories",
    price: 52,
    stock: 28,
    image: gallery(14)[0],
    images: gallery(14),
    size: ["52 × 52 cm"],
    colors: ["Maroon / cream / teal"],
    material: "100% cotton",
    description: [
      "A 52 cm square cotton bandana printed with a sparse cream grid and tiny teal seed shapes. Fold it as a neck scarf, hair accessory, handle tie or protective wrap for small objects.",
      "Natural cotton becomes softer with wear. Printed colour can look different in direct sun and may transfer when new, particularly onto pale fabric if damp.",
      "Cold hand wash separately with mild detergent, reshape while damp and line dry in shade. Do not bleach. Use a cool iron on the reverse and keep loose fabric away from flames and moving equipment.",
    ],
    Features: ["52 cm square", "100% cotton", "Original grid print", "Cold wash separately"],
  },
  {
    id: 15,
    name: "Eventail (Hand Fan)",
    category: "Accessories",
    price: 68,
    stock: 16,
    image: gallery(15)[0],
    images: gallery(15),
    size: ["23 cm folded / 42 cm open"],
    colors: ["Forest green / dark walnut"],
    material: "Cotton leaf, wood ribs and metal pivot",
    description: [
      "A folding hand fan with dark wood ribs and a solid forest-green cotton leaf. It provides a manual breeze and folds to a slim profile for a bag or desk drawer.",
      "Approximate measurements are 23 cm closed and 42 cm across when open. Wood grain and colour vary naturally. The fan is designed for gentle hand use rather than forceful or continuous mechanical motion.",
      "Open and close slowly from the guards, not by pulling the fabric. Keep dry and allow any light moisture to air-dry fully open. The pivot can pinch fingers; keep away from small children and open flames.",
    ],
    Features: ["42 cm open span", "Cotton fan leaf", "Natural wood variation", "Pinch-point caution"],
  },
  {
    id: 16,
    name: "Assiettes Plates (Dinner)",
    category: "Tableware",
    price: 78,
    stock: 25,
    image: gallery(16)[0],
    images: gallery(16),
    size: ["27 cm diameter"],
    colors: ["Off-white / moss green"],
    material: "Glazed stoneware",
    description: [
      "A sturdy off-white dinner plate finished with a double moss-green rim. The lightly speckled glaze and familiar 27 cm format are intended for regular table service.",
      "Each plate is approximately 27 cm across. Speckle density, rim width and base tone may vary slightly between batches. Screen colour is a guide rather than an exact material match.",
      "Dishwasher safe on a gentle cycle and microwave suitable for reheating only when undamaged. Do not use on a hob or under direct flame. Avoid rapid temperature changes and stop using if chipped at the food-contact edge.",
    ],
    Features: ["27 cm dinner size", "Double hand-painted rim", "Gentle-cycle dishwasher safe", "Microwave reheating only"],
  },
  {
    id: 17,
    name: "Yuzu Basil Green Tea",
    category: "Food",
    price: 45,
    stock: 40,
    image: gallery(17)[0],
    images: gallery(17),
    size: ["250 ml"],
    colors: ["Pale green"],
    material: "Bottled green tea infusion",
    description: [
      "A light 250 ml green tea drink blended with yuzu peel, basil, lemon and honey for a gently citrus-herbal profile. Serve chilled and shake only if the delivered label instructs you to do so.",
      "Tea naturally contains caffeine. Ingredients, nutrition, allergen statements and use-by information on the delivered bottle take precedence over this summary; check them before drinking, especially if pregnant, caffeine-sensitive or managing allergies.",
      "Keep sealed and store according to the bottle label. Refrigerate after opening and consume within the stated period. Do not drink if the seal is broken, the glass is damaged, or the liquid appears unexpectedly changed.",
    ],
    Features: ["250 ml glass bottle", "Green tea with citrus and basil", "Contains natural caffeine", "Physical label governs storage"],
    perishable: true,
  },
  {
    id: 18,
    name: "Kola Turmeric Botanical Sparkler",
    category: "Food",
    price: 48,
    stock: 33,
    image: gallery(18)[0],
    images: gallery(18),
    size: ["250 ml"],
    colors: ["Amber"],
    material: "Carbonated botanical beverage",
    description: [
      "A 250 ml lightly sparkling botanical drink built around kola nut, turmeric and citrus. The profile is earthy, tart and only lightly sweet, intended as a chilled occasional refreshment.",
      "Kola nut is a source of caffeine. Always read the delivered bottle for the definitive ingredient, caffeine, allergen and nutrition information. It may not be suitable for children, pregnancy, breastfeeding or people advised to limit caffeine.",
      "Store and refrigerate as directed on the physical label. Open carefully without shaking, and never use a bottle with a lifted cap, crack or leak. Consume within the labelled period after opening.",
    ],
    Features: ["250 ml bottle", "Light carbonation", "Botanical flavour profile", "Contains caffeine"],
    perishable: true,
  },
  {
    id: 19,
    name: "Oak-Aged Apple Spirit — 10 Year",
    category: "Spirits",
    price: 176,
    stock: 11,
    image: gallery(19)[0],
    images: gallery(19),
    size: ["700 ml"],
    colors: ["Deep amber"],
    material: "Apple spirit in a glass bottle",
    description: [
      "A 700 ml apple spirit with a stated ten-year maturation, presented in a squat clear-glass bottle. The deep amber liquid is intended for measured adult servings and offers a rounded oak-and-baked-apple style.",
      "Alcohol strength, producer details, maturation statement and allergens must be verified on the bottle supplied; the physical label controls if it differs from this summary. Bottle colour can shift under different lighting.",
      "Store upright, closed and away from heat or direct sun. Handle the glass carefully and never drink before driving or operating machinery. Sale and supply are restricted to customers aged 18 or over; age declaration and delivery checks may apply.",
    ],
    Features: ["700 ml glass bottle", "Deep amber apple spirit", "Adult purchase only", "Physical label controls product facts"],
    alcohol: true,
  },
  {
    id: 20,
    name: "Oak-Aged Apple Spirit — 5 Year",
    category: "Spirits",
    price: 148,
    stock: 18,
    image: gallery(20)[0],
    images: gallery(20),
    size: ["700 ml"],
    colors: ["Light amber"],
    material: "Apple spirit in a glass bottle",
    description: [
      "A 700 ml light-amber apple spirit carrying a stated five-year maturation. Its cleaner, fruit-forward style is designed for small adult servings from a tall-shouldered clear bottle.",
      "Consult the supplied bottle for confirmed alcohol strength, maturation, producer and allergen information. The online photograph illustrates bottle shape and colour but cannot reproduce every glass or liquid variation.",
      "Keep upright in a cool, shaded place and close after serving. Broken glass is hazardous. Do not drink before driving, during pregnancy, or where alcohol is medically unsuitable. Customers and recipients must be at least 18 years old.",
    ],
    Features: ["700 ml glass bottle", "Light amber apple spirit", "Age declaration required", "Store upright and shaded"],
    alcohol: true,
  },
  {
    id: 21,
    name: "Ripple Amber Bud Vase",
    category: "Vases",
    price: 72,
    stock: 21,
    image: gallery(21)[0],
    images: gallery(21),
    size: ["12 cm diameter × 16 cm high"],
    colors: ["Amber"],
    material: "Hand-blown glass",
    description: [
      "A compact amber bud vase with a gently wavy neck and weighted rounded base. It is proportioned for one or two stems, dried grasses, or an empty sunlit shelf display.",
      "Approximate dimensions are 12 cm diameter and 16 cm high. Tiny bubbles, slight asymmetry and differences in amber depth are natural results of the hand-forming process.",
      "Hand wash in lukewarm water and dry with a lint-free cloth. Avoid boiling water, dishwasher heat, direct flame and abrupt temperature changes. Place on a stable surface and discard if cracked.",
    ],
    Features: ["Hand-blown glass", "Weighted rounded base", "Natural bubble variation", "For one or two stems"],
  },
  {
    id: 22,
    name: "Pebble Blue Serving Bowl",
    category: "Tableware",
    price: 96,
    stock: 15,
    image: gallery(22)[0],
    images: gallery(22),
    size: ["28 × 24 × 8 cm"],
    colors: ["Sand / pale blue"],
    material: "Stoneware with glazed interior",
    description: [
      "A shallow pebble-shaped serving bowl with a tactile matte-sand exterior and glossy pale-blue interior. It is sized for salads, fruit or shared side dishes.",
      "The asymmetric bowl measures approximately 28 × 24 × 8 cm. Shape, speckling and glaze pooling vary subtly between pieces, especially where the matte rim meets the blue glaze.",
      "Hand washing is recommended to preserve the mixed finish. Do not use over direct heat or move from cold storage into very hot water. Protect tabletops from a damp unglazed base and stop use if cracked.",
    ],
    Features: ["Asymmetric pebble shape", "Gloss interior / matte exterior", "Shared serving size", "Hand wash recommended"],
  },
  {
    id: 23,
    name: "Braided Clay Wrist Pouch",
    category: "Accessories",
    price: 84,
    stock: 13,
    image: gallery(23)[0],
    images: gallery(23),
    size: ["20 × 13 cm / 18 cm wrist loop"],
    colors: ["Clay rust / brass tone"],
    material: "Braided cotton cord with metal zip",
    description: [
      "A compact braided cotton wrist pouch with a concealed metal zip and short loop strap. It carries cards, keys and other small daily items without internal compartments.",
      "Approximate body size is 20 × 13 cm with an 18 cm loop. The flexible braid can settle with use, and cotton colour may transfer when wet. It is not designed to protect valuables from water or impact.",
      "Spot clean with a barely damp cloth and air-dry away from sun. Do not machine wash, overload, or pull the zip across trapped fibres. Keep the strap away from moving machinery and supervise children around the loop.",
    ],
    Features: ["Braided cotton body", "Concealed zip", "Short wrist loop", "Not water resistant"],
  },
  {
    id: 24,
    name: "Ribbed Stone Taper Holders",
    category: "Home Decor",
    price: 76,
    stock: 20,
    image: gallery(24)[0],
    images: gallery(24),
    size: ["Set of 2 / 10 cm and 15 cm high"],
    colors: ["Charcoal / sand"],
    material: "Ribbed stoneware",
    description: [
      "A pair of ribbed charcoal stoneware holders in two heights, each finished with an unglazed sand-coloured base. They are made for standard taper candles on a stable, heat-resistant surface.",
      "The set includes approximately 10 cm and 15 cm holders. Natural clay and firing variation can change rib depth and tone. Candles shown are not included.",
      "Never leave a burning candle unattended. Keep away from children, pets, draughts and flammable objects; trim the wick and extinguish before the flame nears the holder. Let wax cool before removal and hand clean without abrasives.",
    ],
    Features: ["Two complementary heights", "Standard taper openings", "Unglazed sand base", "Candles not included"],
  },
  {
    id: 25,
    name: "Cocoa Citrus Truffle Box",
    category: "Food",
    price: 72,
    stock: 29,
    image: gallery(25)[0],
    images: gallery(25),
    size: ["9 pieces / 135 g"],
    colors: ["Dark cocoa / orange"],
    material: "Dark chocolate truffles with candied citrus",
    description: [
      "Nine cocoa-dusted dark chocolate truffles with small candied-orange centres, arranged in a plain recyclable paper box. Allow a few minutes at room temperature before serving for a softer centre.",
      "Approximate net weight is 135 g. May contain milk, nuts, peanuts, gluten, soy and egg; the delivered ingredient and allergen label is definitive and must be checked before consumption.",
      "Store sealed in a cool, dry place away from sunlight and odours, following the physical pack. Do not eat after the labelled date or if the inner packaging is open or damaged. Open food is returnable only when faulty, damaged or incorrectly supplied.",
    ],
    Features: ["Nine-piece box", "Candied-orange centre", "Cocoa-dusted finish", "Allergen label check required"],
    perishable: true,
  },
  {
    id: 26,
    name: "Folded Paper Table Shade",
    category: "Home Decor",
    price: 118,
    stock: 10,
    image: gallery(26)[0],
    images: gallery(26),
    size: ["30 × 16 × 32 cm"],
    colors: ["Ivory / dark oak"],
    material: "Folded fibre-paper shade, wood base and integrated LED module",
    description: [
      "A compact table light built around a fan-folded ivory fibre-paper shade and rounded dark-oak base. The soft glow is intended for bedside or shelf ambience rather than detailed task work.",
      "Approximate dimensions are 30 × 16 × 32 cm. Natural paper fibres and wood grain create visible variation. Use only with the voltage and plug compatibility stated on the supplied electrical label.",
      "For indoor dry locations only. Keep paper away from liquids, steam and other heat sources; do not cover the shade. Unplug and dust with a soft dry brush. Stop use if the cable, plug, paper or base becomes damaged.",
    ],
    Features: ["Folded fibre-paper shade", "Integrated low-heat LED", "Dark-oak base", "Dry indoor use only"],
  },
];

export default productData;
